import React, { useState, useCallback } from 'react';
import { Autocomplete, TextField, Box, Typography, Chip } from '@mui/material';

const EditableSelectCell = ({ id, field, value, label, saveEditedField, darkMode, options, multiple = false, equipment, categoryUuid, workId }) => {
    // Определяем цвета в зависимости от поля
    const getFieldColors = (field) => {
        switch (field) {
            case 'responsible':
                return {
                    bgcolor: darkMode ? 'rgba(211, 47, 47, 0.2)' : 'rgba(211, 47, 47, 0.1)',
                    color: darkMode ? '#f44336' : '#d32f2f',
                    selectedBg: darkMode ? 'rgba(211, 47, 47, 0.2)' : 'rgba(211, 47, 47, 0.1)',
                };
            case 'coexecutors':
                return {
                    bgcolor: darkMode ? 'rgba(245, 124, 0, 0.2)' : 'rgba(245, 124, 0, 0.1)',
                    color: darkMode ? '#ffb74d' : '#f57c00',
                    selectedBg: darkMode ? 'rgba(245, 124, 0, 0.2)' : 'rgba(245, 124, 0, 0.1)',
                };
            case 'equipment':
                return {
                    bgcolor: darkMode ? 'rgba(92, 107, 192, 0.2)' : 'rgba(57, 73, 171, 0.1)',
                    color: darkMode ? '#5c6bc0' : '#3949ab',
                    selectedBg: darkMode ? 'rgba(92, 107, 192, 0.2)' : 'rgba(57, 73, 171, 0.1)',
                };
            case 'stage':
                return {
                    bgcolor: darkMode ? 'rgba(171, 71, 188, 0.2)' : 'rgba(106, 27, 154, 0.1)',
                    color: darkMode ? '#ab47bc' : '#6a1b9a',
                    selectedBg: darkMode ? 'rgba(171, 71, 188, 0.2)' : 'rgba(106, 27, 154, 0.1)',
                };
            case 'closing':
                return {
                    bgcolor: darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)',
                    color: darkMode ? '#ff8f00' : '#e65100',
                    selectedBg: darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)',
                };
            case 'cost':
                return {
                    bgcolor: darkMode ? 'rgba(233, 30, 99, 0.2)' : 'rgba(194, 24, 91, 0.1)',
                    color: darkMode ? '#e91e63' : '#c2185b',
                    selectedBg: darkMode ? 'rgba(233, 30, 99, 0.2)' : 'rgba(194, 24, 91, 0.1)',
                };
            case 'comment':
            case 'name_by_acts':
                return {
                    bgcolor: darkMode ? 'rgba(33, 150, 243, 0.2)' : 'rgba(21, 101, 192, 0.1)',
                    color: darkMode ? '#2196f3' : '#1565c0',
                    selectedBg: darkMode ? 'rgba(33, 150, 243, 0.2)' : 'rgba(21, 101, 192, 0.1)',
                };
            default:
                return {
                    bgcolor: darkMode ? 'rgba(156, 39, 176, 0.2)' : 'rgba(156, 39, 176, 0.1)',
                    color: darkMode ? '#ce93d8' : '#9c27b0',
                    selectedBg: darkMode ? 'rgba(156, 39, 176, 0.2)' : 'rgba(156, 39, 176, 0.1)',
                };
        }
    };

    const fieldColors = getFieldColors(field);
    const [localValue, setLocalValue] = useState(value || (multiple ? [] : null));
    const [inputValue, setInputValue] = useState('');

    const handleChange = (event, newValue) => {
        console.log(event, newValue)
        setLocalValue(newValue);
    };

    const saveEditedEquipment = useCallback((newValue, deleted = null) => {
        saveEditedField({
            rowId: id,
            field: field,
            value: newValue,
            isValueChanged: JSON.stringify(value) !== JSON.stringify(newValue),
            shouldExitEditMode: false,
            deleted: deleted
        });

    }, [])


    const handleInputChange = (event, newInputValue) => {
        console.log(newInputValue)
        setInputValue(newInputValue);
    };

    const handleBlur = () => {

        saveEditedField({
            rowId: id,
            field: field,
            value: multiple ? localValue.map(v => v?.id || v || null) : (localValue?.id || localValue || null),
            isValueChanged: JSON.stringify(value) !== JSON.stringify(localValue),
            shouldExitEditMode: false,
            equipment: equipment,
            categoryUuid: categoryUuid,
            workId: workId,
        });


    };

    const handleClear = () => {
        setLocalValue(multiple ? [] : null);
    };

    const handleSave = () => {
        handleBlur();
    };

    const getOptionLabel = (option) => {
        return option?.name || option?.display_name || String(option || '');
    };

    const isOptionEqualToValue = (option, value) => {
        return option?.id === value?.id;
    };

    return (
        <Autocomplete
            data-editing-cell="true"
            value={localValue}
            onChange={handleChange}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            onBlur={handleBlur}
            options={options || []}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={isOptionEqualToValue}
            multiple={multiple}

            size="small"
            autoFocus
            freeSolo
            disableClearable={true}
            selectOnFocus
            handleHomeEndKeys
            disableCloseOnSelect={multiple}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={label}
                    size="small"
                    rows={multiple ? 3 : 1}
                    sx={{
                        '& .MuiOutlinedInput-input': {

                            cursor: 'text',
                            color: darkMode ? '#ffffff' : '#333',
                            fontSize: '0.875rem',
                            width: 'fit-content !important',
                        },
                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: fieldColors.color,
                            borderWidth: '2px',
                        },
                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
                        },
                        '& .MuiInputLabel-root': {
                            color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                            fontSize: '0.875rem',
                            '&.Mui-focused': {
                                color: fieldColors.color,
                            }
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
                            borderRadius: '4px',
                        },
                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                        '& .MuiInputBase-root': {
                            p: '5px !important',
                            borderRadius: '4px',
                        },
                        '& .MuiInputBase-input': {

                            fontWeight: 500,
                            fontSize: '0.8rem',
                            borderRadius: '4px',
                        },
                    }}
                />
            )}
            renderOption={(props, option) => (
                <Box component="li" {...props}>
                    <Typography variant="body2">
                        {getOptionLabel(option)}
                    </Typography>
                </Box>
            )}
            renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                    <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={getOptionLabel(option)}
                        onClick={() => { }}
                        size="small"
                        sx={{
                            bgcolor: fieldColors.bgcolor,
                            color: fieldColors.color,
                            fontSize: '0.7rem',
                            height: 'auto',
                            minHeight: '20px',
                            '& .MuiChip-label': {
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                textAlign: 'center',
                                lineHeight: '1.2',
                                padding: '2px 6px',
                            },
                        }}
                    />
                ))
            }
            sx={{
                '& .MuiAutocomplete-popper': {
                    zIndex: 1300,
                },
                '& .MuiAutocomplete-paper': {
                    bgcolor: darkMode ? '#2b2b2b' : '#fff',
                    border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
                    '& .MuiAutocomplete-option': {
                        color: darkMode ? '#f5f7fa' : '#333',
                        '&:hover': {
                            bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
                        },
                        '&[aria-selected="true"]': {
                            bgcolor: fieldColors.selectedBg,
                        },
                    },
                },
            }}
        />
    );
};

export default EditableSelectCell;

